import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui';
import './ContulMeu.css';

function ContulMeu() {
    const [user, setUser] = useState(null);
    const [appointments] = useState([]);

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        }
        // TODO: Fetch user appointments from API
    }, []);

    if (!user) {
        return (
            <div className="contul-meu-container">
                <div className="hero-section-cont">
                    <div className="hero-content-cont">
                        <h1 className="contul-meu-title">Contul meu</h1>
                        <p className="hero-subtitle">Gestionați-vă informațiile personale și programările</p>
                    </div>
                </div>
                <div className="contul-meu-content">
                    <div className="login-prompt">
                        <h2>Trebuie să vă autentificați</h2>
                        <p>Pentru a accesa contul dumneavoastră, trebuie să vă autentificați mai întâi.</p>
                        <Button variant="primary" onClick={() => window.location.href = 'https://compas.evoomedical.ro/'}>
                            Autentificare
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="contul-meu-container">
            <div className="hero-section-cont">
                <div className="hero-content-cont">
                    <h1 className="contul-meu-title">Contul meu</h1>
                    <p className="hero-subtitle">Gestionați-vă informațiile personale și programările</p>
                </div>
            </div>

            <div className="contul-meu-content">
                <div className="user-profile-section">
                    <div className="section-header">
                        <div className="section-icon">👤</div>
                        <h2>Informații personale</h2>
                    </div>
                    <div className="profile-info">
                        <div className="info-item">
                            <strong>Nume:</strong> {user.firstName || user.first_name} {user.lastName || user.last_name}
                        </div>
                        <div className="info-item">
                            <strong>Email:</strong> {user.email}
                        </div>
                        <div className="info-item">
                            <strong>Telefon:</strong> {user.phone || 'Nespecificat'}
                        </div>
                        <div className="info-item">
                            <strong>Rol:</strong> {user.role === 'doctor' ? 'Medic' : 'Pacient'}
                        </div>
                    </div>
                    <Button variant="secondary" onClick={() => alert('Funcționalitate în dezvoltare')}>
                        Editează profilul
                    </Button>
                </div>

                <div className="appointments-section">
                    <div className="section-header">
                        <div className="section-icon">📅</div>
                        <h2>Programările mele</h2>
                    </div>
                    <div className="appointments-list">
                        {appointments.length > 0 ? (
                            appointments.map(appointment => (
                                <div key={appointment.id} className="appointment-item">
                                    <h3>{appointment.serviceName}</h3>
                                    <p>Data: {new Date(appointment.date).toLocaleDateString()}</p>
                                    <p>Ora: {appointment.time}</p>
                                    <p>Stare: {appointment.status}</p>
                                </div>
                            ))
                        ) : (
                            <p>Nu aveți programări active.</p>
                        )}
                    </div>
                    <Button variant="primary" onClick={() => window.location.href = '/programare'}>
                        Programează-te
                    </Button>
                </div>

                {user.role === 'doctor' && (
                    <div className="doctor-section">
                        <div className="section-header">
                            <div className="section-icon">⚕️</div>
                            <h2>Panou Doctor</h2>
                        </div>
                        <p>Accesați panoul dumneavoastră de doctor pentru a gestiona programările și pacienții.</p>
                        <Button variant="primary" onClick={() => window.location.href = '/doctor-admin'}>
                            Deschide panoul doctor
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ContulMeu;
